import React from "react";
import PracticeAreas from "./PracticeAreas";

const CoreStrengths = () => {
  return <PracticeAreas focusTarget="core-strengths" />;
};

export default CoreStrengths;
